(() => {
  if (window.SpotmateArticleSocialVideo) return;
  window.SpotmateArticleSocialVideo = true;

  const mountPlayer = (container) => {
    if (!container || container.dataset.playerMounted === 'true') return;
    const source = container.dataset.playerSrc;
    if (!source) return;

    container.dataset.playerMounted = 'true';
    const iframe = document.createElement('iframe');
    iframe.src = source;
    iframe.title = container.dataset.playerTitle || 'Social video player';
    iframe.loading = 'lazy';
    iframe.allow = 'autoplay; fullscreen';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = '0';
    iframe.addEventListener('load', () => container.replaceChildren(iframe), { once: true });
    container.appendChild(iframe);
  };

  const observePlayers = () => {
    const players = document.querySelectorAll('[data-article-social-player]');
    if (!players.length) return;

    if (!('IntersectionObserver' in window)) {
      players.forEach(mountPlayer);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.45) return;
        observer.unobserve(entry.target);
        mountPlayer(entry.target);
      });
    }, { threshold: 0.45 });

    players.forEach((player) => observer.observe(player));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observePlayers, { once: true });
  } else {
    observePlayers();
  }
})();
